import { type GetHookResponse } from '../hooks'
import { featureGetKey } from '../keys'
import { useTantalimQuery } from '../query'
import { type FeatureGetInput, type FeatureGetSuccess } from '@terros/common'

export function useFeatureInfo(input: FeatureGetInput): GetHookResponse<FeatureGetSuccess> {
  return useTantalimQuery<FeatureGetInput, FeatureGetSuccess, FeatureGetSuccess>({
    url: '/feature/get',
    queryKey: featureGetKey(input),
    input,
    convertResponse: (data) => data,
  })
}
